export default "__VITE_ASSET__Brob7K43__"